/* =============================================================================
   Furniselan — product card
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once;

  function initProductCardSwatches(ctx) {
    // Swatches trigger the variant popup modal (handled by variant-popup.js).
    // Primary product card image and state do not change on swatch click.
  }

  /* ── Quick View: sync title when a colour swatch is clicked inside the modal ── */
  function initQuickViewSwatchTitleSync(ctx) {
    var modal = qs('[data-quick-view-modal]');
    if (!modal) return;

    function updateQVTitle(colorVal) {
      if (!colorVal) return;
      var titleEl = qs('.quick-view__title, [data-qv-title-base]', modal);
      if (!titleEl) return;
      var colorEl = qs('[data-qv-color]', titleEl);
      var baseEl = qs('[data-qv-base]', titleEl);
      var base = (baseEl && baseEl.textContent.trim()) || titleEl.getAttribute('data-qv-title-base') || '';
      if (colorEl) {
        colorEl.textContent = ' - ' + colorVal;
      } else {
        titleEl.innerHTML = '<span data-qv-base>' + base + '</span><span data-qv-color> - ' + colorVal + '</span>';
      }
    }

    modal.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-color-swatch], .swatch');
      if (!swatch) return;
      var radio = swatch.querySelector('input[type="radio"]') || (swatch.matches('input') ? swatch : null);
      var colorVal = swatch.getAttribute('data-color-value') || (radio && radio.value);
      if (!colorVal) {
        var nameSpan = swatch.querySelector('.swatch__name');
        if (nameSpan) colorVal = nameSpan.textContent.trim();
      }
      if (colorVal) updateQVTitle(colorVal);
    });

    modal.addEventListener('change', function (e) {
      var radio = e.target.closest('input[data-option-select], input[type="radio"]');
      if (radio && radio.value) {
        updateQVTitle(radio.value);
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Product Card Image Slider
     - Desktop mouse: hover → slide 1; mouseleave → slide 0; click-drag to swipe
     - Touch (mobile / tablet / Chrome device mode): TOUCH events with a
       non-passive touchmove, so the browser never steals the horizontal swipe
       (pointer events + preventDefault cannot stop scrolling, which caused the
       "moves a little then snaps back" bug).
     ------------------------------------------------------------------------ */
  var sliderImageObserver = typeof window.IntersectionObserver === 'function'
    ? new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.loading = 'eager';
        sliderImageObserver.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' })
    : null;

  function initProductCardSliders(ctx) {
    var scope = ctx || document;
    qsa('[data-slider-count]', scope).forEach(function (media) {
      if (media._pcsInit) return;
      media._pcsInit = true;

      var track   = qs('[data-pcs-track]',    media);
      var slides  = qsa('[data-pcs-slide]',   media);
      var sliderHost = media.parentElement;
      var prevBtn = qs('[data-pcs-prev]', sliderHost);
      var nextBtn = qs('[data-pcs-next]', sliderHost);
      var segs    = qsa('[data-pcs-seg]',     media);
      var total   = slides.length;
      var current = 0;
      var startX = 0, startY = 0, diffX = 0, diffY = 0;
      var tracking = false, isDragging = false, suppressClick = false;
      var mousePointerId = null;
      var suppressClickTimer = null;
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (!track || total <= 1) return;

      /* Horizontal swipe is handled by JS, vertical scroll stays with the browser */
      media.style.touchAction = 'pan-y';
      media.style.webkitUserSelect = 'none';
      media.style.userSelect = 'none';
      media.style.webkitTouchCallout = 'none';

      function loadSlide(idx) {
        var image = slides[idx];
        if (image && image.tagName === 'IMG') {
          if (image.dataset.src) {
            if (image.dataset.srcset) image.srcset = image.dataset.srcset;
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
            image.removeAttribute('data-srcset');
          }
          if (image.loading === 'lazy') {
            image.loading = 'eager';
          }
        }
      }

      function goTo(idx) {
        if (idx < 0) idx = 0;
        if (idx >= total) idx = total - 1;
        current = idx;
        loadSlide(idx);
        track.style.transform = 'translate3d(-' + (idx * 100) + '%, 0, 0)';
        segs.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        loadSlide(idx + 1);
      }

      /* ── shared drag logic (used by touch + mouse) ── */
      function beginDrag(x, y) {
        tracking = true;
        isDragging = false;
        startX = x;
        startY = y;
        diffX = 0;
        diffY = 0;
        if (suppressClickTimer) {
          window.clearTimeout(suppressClickTimer);
          suppressClickTimer = null;
        }
        suppressClick = false;
      }

      function moveDrag(x, y, e) {
        if (!tracking) return;
        diffX = x - startX;
        diffY = y - startY;

        if (!isDragging) {
          if (Math.abs(diffX) <= 6 && Math.abs(diffY) <= 6) return;
          if (Math.abs(diffX) <= Math.abs(diffY)) {
            /* vertical gesture → let the page scroll */
            tracking = false;
            return;
          }
          isDragging = true;
          track.classList.add('is-dragging');
        }

        if (e && e.cancelable) e.preventDefault();
        loadSlide(current + (diffX < 0 ? 1 : -1));

        var resistedDiff = diffX;
        if ((current === 0 && diffX > 0) || (current === total - 1 && diffX < 0)) {
          resistedDiff *= 0.25;
        }
        var direction = resistedDiff < 0 ? '-' : '+';
        track.style.transform = 'translate3d(calc(-' + (current * 100) + '% ' + direction + ' ' + Math.abs(resistedDiff) + 'px), 0, 0)';
      }

      function endDrag(commit) {
        tracking = false;
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('is-dragging');
        var threshold = Math.min(40, media.offsetWidth * 0.15);
        if (commit && Math.abs(diffX) > threshold && Math.abs(diffX) > Math.abs(diffY)) {
          goTo(current + (diffX < 0 ? 1 : -1));
        } else {
          goTo(current);
        }
        suppressClick = true;
        if (suppressClickTimer) window.clearTimeout(suppressClickTimer);
        suppressClickTimer = window.setTimeout(function () {
          suppressClick = false;
          suppressClickTimer = null;
        }, 700);
      }

      /* ── TOUCH (mobile, tablet, Chrome device mode) ── */
      media.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        var t = e.touches[0];
        beginDrag(t.clientX, t.clientY);
      }, { passive: true });

      media.addEventListener('touchmove', function (e) {
        if (!tracking || e.touches.length !== 1) return;
        var t = e.touches[0];
        moveDrag(t.clientX, t.clientY, e);
      }, { passive: false });

      media.addEventListener('touchend', function () { endDrag(true); }, { passive: true });
      media.addEventListener('touchcancel', function () { endDrag(true); }, { passive: true });

      /* ── MOUSE (desktop click-drag) — touch pointers are ignored here ── */
      function onPointerDown(e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('[data-pcs-prev], [data-pcs-next]')) return;
        mousePointerId = e.pointerId;
        beginDrag(e.clientX, e.clientY);
        if (media.setPointerCapture) {
          try { media.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      function onPointerMove(e) {
        if (e.pointerType !== 'mouse' || mousePointerId !== e.pointerId) return;
        moveDrag(e.clientX, e.clientY, e);
      }
      function onPointerUp(e) {
        if (e.pointerType !== 'mouse' || mousePointerId !== e.pointerId) return;
        mousePointerId = null;
        endDrag(true);
      }
      function onPointerCancel(e) {
        if (e.pointerType !== 'mouse' || mousePointerId !== e.pointerId) return;
        mousePointerId = null;
        endDrag(true);
      }

      media.addEventListener('pointerdown', onPointerDown);
      media.addEventListener('pointermove', onPointerMove);
      media.addEventListener('pointerup', onPointerUp);
      media.addEventListener('pointercancel', onPointerCancel);
      media.addEventListener('lostpointercapture', onPointerCancel);

      media.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if (sliderImageObserver) {
        sliderImageObserver.observe(slides[1]);
      }

      /* Desktop hover: slide 1 on enter, slide 0 on leave */
      if (canHover && sliderHost) {
        sliderHost.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          loadSlide(1);
          if (current === 0) goTo(1);
        });
        sliderHost.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse' || isDragging) return;
          goTo(0);
        });
      }

      /* Arrow clicks — controls are siblings of the image link. */
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(current + 1); });

      /* Block the link click that can follow a drag */
      media.addEventListener('click', function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    });
  }

  window.FS.initProductCardSwatches = initProductCardSwatches;
  window.FS.initQuickViewSwatchTitleSync = initQuickViewSwatchTitleSync;
  window.FS.initProductCardSliders = initProductCardSliders;

  /* Auto-bind on page load */
  (function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initQuickViewSwatchTitleSync(document);
        initProductCardSliders(document);
      });
    } else {
      initQuickViewSwatchTitleSync(document);
      initProductCardSliders(document);
    }
  }());
})();